import { setAppState } from '~/App'
import { SYMBOLSType } from '~/types'

const basketPath = 'FutureCloud.orders' // localStorage key


export const isDev = process.env.NODE_ENV === 'development'


export function getBasketItems(): string[] {
  return localStorage.getItem(basketPath) ? localStorage.getItem(basketPath)!.split(',') : []
}

export function addBasketItem(id: number | string): void {
  const basket = getBasketItems()
  basket.push(id.toString())
  localStorage.setItem(basketPath, basket.toString())
  setAppState({basket})
}

export function removeBasketItem(ix: number): void {
  const basket = getBasketItems()
  basket.splice(ix, 1)
  localStorage.setItem(basketPath, basket.toString())
  setAppState({basket})
}

export function clearBasketItems(): void {
  localStorage.removeItem(basketPath)
  setAppState({basket: []})
}


export const cryptoAddressAPI = { // TODO
  BTC: '0xabcBTCaddress',
  ETH: '0xabcETHaddress',
  LTC: '0xabcLTCaddress',
}


export const SYMBOLS: SYMBOLSType = {
  BTC: { unit: 'BTC', decimals: 5, prefix: '',  postfix: ''   },
  CZK: { unit: 'CZK', decimals: 2, prefix: '',  postfix: ',-' },
  ETH: { unit: 'ETH', decimals: 4, prefix: 'Ξ', postfix: ''   },
  EUR: { unit: 'EUR', decimals: 2, prefix: '€', postfix: ''   },
  LTC: { unit: 'LTC', decimals: 3, prefix: '',  postfix: ''   },
  USD: { unit: 'USD', decimals: 2, prefix: '$', postfix: ''   },
  /**
   * Formats currency to fixed decimal length
   */
  format(value, currency) {
    return Number(value).toFixed(this[currency].decimals)
  },
  /**
   * Adds currency short symbols to fixed decimal length value
   */
  sformat(value, currency) {
    const c = this[currency]
    return c.prefix + Number(value).toFixed(c.decimals) + c.postfix
  },
  /**
   * Adds currency long symbols to fixed decimal length value
   */
  lformat(value, currency) {
    const c = this[currency]
    return Number(value).toFixed(c.decimals) + ' ' + c.unit
  },
}



// WEBPACK FOOTER //
// ./src/utils/index.ts